import React from 'react';
import ScreenshotPreview from '../shared/ScreenshotPreview';

const WebsiteHeader = ({ mainUrl, websiteScreenshot, websiteMobileScreenshot, onScreenshotClick }) => {
    return (
        <div style={{ 
            marginBottom: '30px',
            display: 'flex',
            gap: '20px',
            alignItems: 'flex-start'
        }}>
            <div style={{ flex: 1 }}>
                <a 
                    href={mainUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ 
                        fontSize: '16px',
                        color: '#64b5f6',
                        textDecoration: 'none',
                        wordBreak: 'break-all',
                        fontWeight: '500'
                    }}
                >
                    <h4 style={{ marginBottom: '10px', color: '#e0e0e0', fontWeight: '600' }}>{mainUrl}</h4>
                </a>
                {(websiteScreenshot || websiteMobileScreenshot) && (
                    <div style={{
                        display: 'flex',
                        gap: '16px',
                        flexWrap: 'wrap'
                    }}>
                        {websiteScreenshot && (
                            <ScreenshotPreview
                                label="Desktop"
                                screenshot={websiteScreenshot}
                                onClick={() => onScreenshotClick('desktop')}
                            />
                        )}
                        {websiteMobileScreenshot && (
                            <ScreenshotPreview
                                label="Mobile"
                                screenshot={websiteMobileScreenshot}
                                onClick={() => onScreenshotClick('mobile')}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WebsiteHeader;






